module.exports = __webpack_public_path__ + "images/emoji/parking.41ecf5a6cf1be4fb935a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/parking.png
// module id = KUSq
// module chunks = 1